import React from 'react';
import { useTranslation } from 'react-i18next';

export const SpecSheet: React.FC = () => {
  const { t } = useTranslation();

  const rows = [
    { labelKey: 'specSheet.mainRoleLabel', valKey: 'specSheet.mainRoleVal', isPrimary: true },
    { labelKey: 'specSheet.experienceLabel', valKey: 'specSheet.experienceVal', isHighlight: true },
    { labelKey: 'specSheet.focusLabel', valKey: 'specSheet.focusVal' },
    { labelKey: 'specSheet.languagesLabel', valKey: 'specSheet.languagesVal' },
    { labelKey: 'specSheet.workModelLabel', valKey: 'specSheet.workModelVal' },
    { labelKey: 'specSheet.locationLabel', valKey: 'specSheet.locationVal' },
  ];

  return (
    <div className="bg-[#0B0E17] border border-gray-800 p-6 space-y-5 font-mono text-xs">
      <div className="flex justify-between items-center border-b border-gray-800 pb-3">
        <span className="text-gray-500">{t('specSheet.header')}</span>
        <span className="text-[#00F0FF]">{t('specSheet.name')}</span>
      </div>

      <div className="space-y-3.5 text-gray-300">
        {rows.map((row) => (
          <div key={row.labelKey} className="grid grid-cols-[110px_1fr] items-baseline gap-3">
            <span className="text-gray-500 shrink-0 uppercase">{t(row.labelKey)}</span>
            <span 
              className={`text-right leading-normal ${
                row.isHighlight 
                  ? 'text-[#00F0FF] font-semibold' 
                  : row.isPrimary 
                  ? 'text-gray-200 font-semibold' 
                  : 'text-gray-200'
              }`}
            >
              {t(row.valKey)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
